export const GET_USERS = "GET_USERS"
export const GET_USER = "GET_USER";
export const SEARCH_USERS = "SEARCH_USERS";
export const SEARCH_BY_USERNAME = "SEARCH_BY_USERNAME";
export const CHANGE_EMAIL = "CHANGE_EMAIL";
export const USER_ERROR = "USER_ERROR";
export const GET_POST_BY_USER_ID = "GET_POST_BY_USER_ID";
export const GET_USER_POSTS = "GET_USER_POSTS";
export const GET_USER_BY_ID = "GET_USER_BY_ID";


 